import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./QuickLinks.module.scss";

import cx from "clsx";
import React from "react";
import { A11y, Navigation, Scrollbar, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useClientSide } from "../../../hooks/useClientSide";
import { useIsTouchDevice } from "../../../hooks/useIsTouchDevice";
import QuickLinksItem, { type QuickLinksItemProps } from "../QuickLinksItem";

export interface QuickLinksProps {
	items: QuickLinksItemProps[];
	isHomePage?: boolean;
}

export const QuickLinks: React.FC<QuickLinksProps> = ({
	items,
	isHomePage,
}) => {
	const isClientSide = useClientSide();
	const touchDevice = useIsTouchDevice();
	if (!isClientSide)
		return (
			<div
				className={cx(styles.quicklinkswrapper, {
					[styles.onHomePage]: isHomePage,
				})}
			/>
		);
	return (
		<div
			className={cx(styles.quicklinkswrapper, {
				[styles.onHomePage]: isHomePage,
			})}
			style={{
				width: "100%",
			}}
		>
			<div className={styles.swiperwrapper}>
				<Swiper
					key={items.length}
					className={styles.swiper}
					modules={[Virtual, Navigation, A11y, Scrollbar]}
					edgeSwipeThreshold={10}
					threshold={0}
					grabCursor={true}
					longSwipes={true}
					resistance={false}
					shortSwipes={!!touchDevice}
					loop={false}
					centeredSlides={true}
					scrollbar={{ draggable: true }}
					noSwiping={items.length <= 3}
					initialSlide={0}
					breakpoints={{
						0: {
							slidesPerView: 2.5,
							enabled: items.length >= 3,
							spaceBetween: 0,
							autoplay: {
								delay: 1500,
							},
							centeredSlides: false,
						},
						414: {
							slidesPerView: 3.5,
							enabled: items.length >= 4,
							spaceBetween: 0,
							autoplay: {
								delay: 1500,
							},
							centeredSlides: false,
						},
						600: {
							slidesPerView: 6,
							enabled: false,
							spaceBetween: 0,
							autoplay: {
								delay: 1500,
							},
							centeredSlides: false,
						},
					}}
				>
					{items.map((quickLinks, i) => (
						<SwiperSlide key={quickLinks.title}>
							<QuickLinksItem
								{...quickLinks}
								isHomePage={isHomePage}
								isLastItem={items.length - 1 === i}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};

export default QuickLinks;
